import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { Button, CircularProgress, Box } from "@mui/material";
import { useUser } from "../../hooks/useUser";
import { useEffect } from "react";

const ManageProfile = () => {
  const navigate = useNavigate();
  const { profile, isProfileLoading } = useUser();

  if (isProfileLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div className="main_title">
        <h1>Manage Profile</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Profile
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <h2>General Details</h2>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-profile/edit")}><EditIcon /> Edit Profile</Button>
          </div>
        </div>
        <div className="gap_p">
          <div className="vew_img w_100">
            {/* <h6>Image</h6> */}
            <figure>
              <img 
                alt={profile?.fullName || "user"} 
                src={profile?.image || "/static/images/admin_icon.png"}
                onError={(e) => {
                  // Fallback to default image if the profile image fails to load
                  const target = e.target as HTMLImageElement;
                  target.src = "/static/images/admin_icon.png";
                }}
              />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>{profile?.fullName || "N/A"}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{profile?.email || "N/A"}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{profile?.countryCode && profile?.phone ? `${profile.countryCode} ${profile.phone}` : "N/A"}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageProfile;
